import { gql } from 'urql';

export const FloatRangeFragment = gql`
  fragment FloatRangeFragment on FloatRange {
    __typename
    max
    min
  }
`;
